import React from "react";
import notcartimg from "../../images/shopping cart.png"
import { NavLink } from "react-router-dom";
const Nocart = () => {
    return (
        <div className="notlogin">
            <img src={notcartimg}></img>
            <div className="notlogintitle">Your Cart is empty</div>
            <div className="notloginsubtitle">There nothing in the cart. Let’s add some items.</div>
            <NavLink to="/" className="notloginbtn textdecoration-none" >Keep exploring</NavLink>

        </div>
    )
}
export default Nocart;